import { Link } from "react-router-dom";
import WatchImg from "./WatchImg";

const isPresent = (value) =>
  value !== null && value !== undefined && String(value).trim() !== "";

const ProductCard = ({ watch, index = 0 }) => {
  // product_images can come back null (not just empty) for products with no photos.
  // The optional chain used to be on `watch` only, so `product_images[0]` threw and
  // took the whole grid down with it.
  const images = Array.isArray(watch?.product_images)
    ? watch.product_images
    : [];
  const reference = watch?.product_reference?.reference;
  // Some values are hidden per watch (missing/null); join only the ones present.
  const packageLine = [
    watch?.product_watchdetail?.year,
    watch?.product_condition?.package_content,
  ]
    .filter(isPresent)
    .join(" / ");

  return (
    <Link
      to={`/watches/${watch?.id}`}
      className="product-card"
      style={{ animationDelay: `${index * 0.08}s`, textDecoration: "none" }}
    >
      <div className="product-img-wrap">
        <WatchImg
          className="img-main"
          src={images[0]?.file_url}
          alt={watch?.name}
        />
        {images[1]?.file_url && (
          <WatchImg
            className="img-hover"
            src={images[1]?.file_url}
            alt={watch?.name}
          />
        )}
        <div className="product-quick-view">View Details</div>
      </div>
      <div className="product-brand">
        {watch?.brand?.name}{" "}
        {isPresent(reference) && (
          <div className="product-reference">{reference}</div>
        )}
      </div>
      <div className="product-name">{watch?.name}</div>
      {watch?.is_show_price ? (
        <div className="product-price">
          Rp {watch?.selling_price?.toLocaleString("id-ID")}
        </div>
      ) : (
        <div className="product-price product-ask-price">Ask for Price</div>
      )}
      {packageLine && <div className="product-package">{packageLine}</div>}
    </Link>
  );
};

export default ProductCard;
